// Supabase configuration - shared across the app
// This allows components to access the URL and key for direct API calls

// Determine if we're in development or production
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");
const _isVercel = // eslint-disable-line no-unused-vars
  typeof window !== "undefined" &&
  window.location.hostname.includes("vercel.app");
const _isDevelopment = process.env.NODE_ENV === "development" || isLocalhost; // eslint-disable-line no-unused-vars

// Development configuration (local Supabase)
const devConfig = {
  url: process.env.REACT_APP_SUPABASE_LOCAL_URL || "http://127.0.0.1:54321",
  key:
    process.env.REACT_APP_SUPABASE_LOCAL_ANON_KEY ||
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0",
};

// Production configuration (cloud Supabase) - now using environment variables
// Uses the new publishable key (public, RLS-constrained) instead of the legacy anon JWT.
const prodConfig = {
  url:
    process.env.REACT_APP_SUPABASE_URL ||
    "https://ehvieoowaaocxhtavown.supabase.co",
  key: (
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    "sb_publishable_fQ8N8N5PdD_oBuHHxP9j6A_0sYT7h3S"
  ).replace(/\s/g, ""),
};

// Force production mode on Vercel, regardless of NODE_ENV
// Override with environment variable if needed
const useProduction =
  process.env.REACT_APP_FORCE_PRODUCTION === "true" ||
  process.env.REACT_APP_USE_PRODUCTION !== "false"; // Default to true

// Use appropriate config based on environment
export const supabaseConfig = useProduction ? prodConfig : devConfig;

// Export individual values for easy access
export const {
  url: SUPABASE_URL,
  key: SUPABASE_ANON_KEY,
} = supabaseConfig;
